import HeroBanner from "../components/homePage/HeroBanner";
import HeroSection from "../components/homePage/HeroSection";
import ZenconCapabilities from "../components/homePage/ZenconCapabilities";
import WhySection from "../components/homePage/WhySection";
import SapPartnerSection from "../components/homePage/SapPartnerSection ";
import SEO from "../components/commonComponents/SEO";

export default function Home() {
  const scrollToCapabilities = () => {
    const section = document.getElementById("capabilities-section");

    section?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <>
      <SEO
        title="ZENCON | SAP Services & Digital Transformation Solutions"
        description="ZENCON provides SAP consulting, SAP implementation, SAP support, digital transformation, cloud services, custom application development, data analytics, AI, IoT, and automation solutions in Saudi Arabia."
        keywords="ZENCON, SAP services Saudi Arabia, SAP consulting, SAP implementation, SAP support, digital transformation Saudi Arabia, cloud services, custom application development, business intelligence, AI automation"
        url="https://www.zencon-sa.com/"
        image="https://www.zencon-sa.com/images/default-image.png"
      />
      <HeroBanner />
      <HeroSection scrollToCapabilities={scrollToCapabilities} />
      <div id="capabilities-section">
        <ZenconCapabilities />
      </div>
      <WhySection />
      <SapPartnerSection />
    </>
  );
}
